// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WbUX","colMin":"styles_colMin__3T1-A"};